module.exports = __webpack_public_path__ + "static/media/delivery-truck.c2acec52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delivery-truck.svg
// module id = 945
// module chunks = 5